import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { Card, Button, Table, Row, Col } from "react-bootstrap";
import ChartsContext from "contexts/ChartsContext";

const TodayRegistration = ({ handleCSVDownload, handleTableClose }) => {
    const { updateTime, setUpdateTime } = useContext(ChartsContext);
    const [showTotalToday, setShowTotalToday] = useState([]);  // State to store the volunteers data

    const fetchVolunteers = () => {
        axios.get(`${process.env.REACT_APP_SERVER_URL}/vegefest/getTodayRegistration`)
            .then(response => {
                setShowTotalToday(response.data);  // Store the volunteers data in state
                const currentTime = new Date().toLocaleString();
                setUpdateTime(currentTime);
            })
            .catch(error => {
                console.error("Error fetching Today's Registration Guest List:", error);
            });
    };

    useEffect(() => {
        fetchVolunteers();
    }, []);

    return (
        <>
            <Card className="card-stats">
                <Card.Header>
                    <Row>
                        <Col>
                            <Card.Title as="h4">今日報名的來賓列表</Card.Title>
                            <p className="card-category">Table of Guests Who Registered Today</p>
                        </Col>
                        <Col className="text-right">
                            <Button variant="info" onClick={() => handleCSVDownload(showTotalToday, 'todays_registration')} className='mr-3'>
                                Download to CSV
                            </Button>
                            <Button variant="danger" onClick={handleTableClose}>
                                Close Table
                            </Button>
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body>
                    <Table className="table-hover table-striped">
                        <thead>
                            <tr>
                                <th>Guest ID</th>
                                <th>Name</th>
                                <th>Chinese Name</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>Registration Time</th>
                                <th>Check-in Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {showTotalToday.map((reg) => (
                                <tr key={reg.id}>
                                    <td>{reg.id}</td>
                                    <td>{reg.firstname} {reg.lastname}</td>
                                    <td>{reg.chinesename || 'N/A'}</td>
                                    <td>{reg.phone}</td>
                                    <td>{reg.email}</td>
                                    <td>{new Date(reg.registrationTime).toLocaleString()}</td>
                                    <td>{reg.checkedInTime ? new Date(reg.checkedInTime).toLocaleString() : 'Not Checked in Yet'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Card.Body>
                <Card.Footer>
                    <hr />
                    <div className="stats">
                        <i className="fas fa-redo mr-1"></i>
                        Updated at <span className="font-weight-bold">{updateTime}</span>
                    </div>
                </Card.Footer>
            </Card>
        </>
    );
}

export default TodayRegistration;
